export function licenseIsExpiring() {
    return function (license, licenseType) {
        const currentDate = new Date();
        if (
            license.fontRights[licenseType] &&
            license.fontRights[licenseType].end
        ) {
            const compareDate = new Date(license.fontRights[licenseType].end);
            compareDate.setDate(compareDate.getDate() - 30);
            return compareDate < currentDate;
        } else {
            return false;
        }
    };
}
